import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import PROVIDER_TYPES from '../../../providerTypes';
import isValidDnsName from '@/util/isValidDnsName';

export default function NodeNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  provider_type,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (
      provider_type === PROVIDER_TYPES.GCP.value &&
      !/^(?:[a-z](?:[-a-z0-9]{0,61}[a-z0-9])?)$/.test(newValue)
    ) {
      setError(
        `GCP Node name must be a match of regex '(?:[a-z](?:[-a-z0-9]{0,61}[a-z0-9])?)'`
      );
    } else if (newValue === '') {
      setError('Node name cannot be blank');
    } else if (!isValidDnsName(newValue)) {
      setError('Node name must be a valid DNS name');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Node Name'
          id='name'
          aria-describedby='name-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter a name for the node
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
